import React from 'react'
import type { SortKey } from './types'

export type CategoryKey = 'all' | 'beans' | 'dripbag' | 'gift' | 'gear'

interface ShopToolbarV2Props {
  count: number
  sort: SortKey
  onSortChange: (s: SortKey) => void
  category: CategoryKey
  onCategoryChange: (c: CategoryKey) => void
  currentLang: 'zh' | 'en'
}

const ShopToolbarV2: React.FC<ShopToolbarV2Props> = ({
  count,
  sort,
  onSortChange,
  category,
  onCategoryChange,
  currentLang,
}) => {
  const isZh = currentLang === 'zh'

  return (
    <div className="flex flex-col gap-3 border-b border-black/10 py-4 mb-10 md:mb-14 sm:flex-row sm:items-center sm:justify-between">
      <span
        className="text-xs text-black/60"
        style={{ letterSpacing: '0.05em' }}
      >
        {isZh ? `${count} 件商品` : `${count} products`}
      </span>

      <div className="flex items-center gap-3 flex-wrap">
        {/* Category switcher */}
        <span
          className="hidden sm:inline text-xs text-black/50"
          style={{ letterSpacing: '0.05em' }}
        >
          {isZh ? '分類' : 'Category'}
        </span>
        <select
          value={category}
          onChange={(e) => onCategoryChange(e.target.value as CategoryKey)}
          className="border border-black/15 bg-white px-3 py-1.5 text-xs text-black focus:border-black focus:outline-none"
          style={{ letterSpacing: '0.04em' }}
        >
          <option value="all">{isZh ? '全部商品' : 'All'}</option>
          <option value="beans">{isZh ? '咖啡豆' : 'Beans'}</option>
          <option value="dripbag">{isZh ? '濾掛' : 'Drip Bag'}</option>
          <option value="gift">{isZh ? '禮盒' : 'Gift Box'}</option>
          <option value="gear">{isZh ? '器材' : 'Gear'}</option>
        </select>

        {/* Divider */}
        <span className="hidden sm:block h-4 w-px bg-black/10 mx-1" />

        {/* Sort */}
        <span
          className="hidden sm:inline text-xs text-black/50"
          style={{ letterSpacing: '0.05em' }}
        >
          {isZh ? '排序' : 'Sort'}
        </span>
        <select
          value={sort}
          onChange={(e) => onSortChange(e.target.value as SortKey)}
          className="border border-black/15 bg-white px-3 py-1.5 text-xs text-black focus:border-black focus:outline-none"
          style={{ letterSpacing: '0.04em' }}
        >
          <option value="featured">{isZh ? '推薦' : 'Featured'}</option>
          <option value="newest">{isZh ? '最新上架' : 'Newest'}</option>
          <option value="price-asc">{isZh ? '價格：低 → 高' : 'Price: Low to High'}</option>
          <option value="price-desc">{isZh ? '價格：高 → 低' : 'Price: High to Low'}</option>
        </select>
      </div>
    </div>
  )
}

export default ShopToolbarV2
